<div class="platform-menu-container {{ project }}">
  <div class="content {{ isCheckout ? 'checkout' : '' }}">
    <div class="logo">
     <ng-content select="[logo]"></ng-content>
    </div>
    <div class="navigation {{ project }}">
     <ng-content select="[navigation]"></ng-content>
      <div class="icons">
        <ng-content select="[icons]"></ng-content>
      </div>
    </div>
  </div>
  <div class="searchbox">
    <ng-content select="[searchBox]"></ng-content>
  </div>
</div>
